const _ = {
  CHAPTER_CROWN_ICON: 4,
  CHAPTER_PLUS_ICON: 2,
  CHAPTER_PROGRESS_SVG: 1,
  LPAR_SHEET_ITEM_BOTTOM_DASH_BOX: 1,
  LPAR_SHEET_ITEM_TOP_VERTICAL_ICON: 2,
  MODAL: 20,
  SAT_SUMMARY_SCORE: 25,
  //* SAT_SUMMARY_SCORE > MODAL
  CANVAS_SCRIBBLING: 26,
  //* CANVAS_SCRIBBLING > Learnosity
  QUESTION_TIPS: -1,
  DESMOS_CALCULATOR: 2,
  GOAL_CHAPTER_SHEETS_MENU: 4
};
export {
  _ as ZINDEX
};
//# sourceMappingURL=z-index.js.map
